module.exports = __webpack_public_path__ + "img/education-email-management.5d1dde26.png";